import React, {Fragment, useState} from 'react';
import {Layout, Menu} from "antd";
import ProgramInformation from "./Content/ProgramInformation";
import EnrolledStudents from "./Content/EnrolledStudents";
import CourseManagement from "./Content/CourseManagement";
import {
    UserOutlined,
    SnippetsOutlined,
    FormOutlined,
    DiffOutlined,
} from "@ant-design/icons";
import CurriculumManagement from "./Content/CurriculumnManagement";
import DisciplineManagement from "./Content/DisciplineManagement";


const {Sider, Content} = Layout;

function TabPanel(props) {
    const {children, value, index} = props;
    return (
        <div hidden={value != index}>
            {children}
        </div>
    );
}

function ProgramDetails(props) {
    const [value, setValue] = useState(1);
    const testFunction = (props) => {
        setValue(props);
    };

    return (
        <Fragment>
            <div className="content-wrapper">
                <div className="content-header"></div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <section className="col-lg-12">
                                <div className="">
                                    <Layout>
                                        <Content style={{padding: "0 0px"}}>
                                            <Layout
                                                className="site-layout-background"
                                                style={{padding: 0, height: "85vh"}}>
                                                <Sider
                                                    className="site-layout-background"
                                                    width={300}
                                                    style={{
                                                        backgroundColor: "white",
                                                        borderRight: "20px solid #f4f6f9",
                                                    }}>
                                                    <div className="details-layout course-background"></div>
                                                    <div className="b-background">
                                                        <div className="b-icon book-icon"></div>
                                                        <div className="b-body">
                                                            <h6 className="" style={{alignText: ""}}>Program
                                                                Details</h6>
                                                        </div>
                                                    </div>

                                                    <Menu mode="inline" defaultSelectedKeys={["1"]}
                                                          style={{backgroundColor: "white"}}>

                                                        <Menu.Item key="1" icon={<SnippetsOutlined/>} onClick={(e) => {
                                                            testFunction(e.key);
                                                        }}>
                                                            Program Information
                                                        </Menu.Item>

                                                        <Menu.Item key="2" icon={<FormOutlined/>} onClick={(e) => {
                                                            testFunction(e.key);
                                                        }}>
                                                            Enrolled Students
                                                        </Menu.Item>

                                                        <Menu.Item key="3" icon={<DiffOutlined/>} onClick={(e) => {
                                                            testFunction(e.key);
                                                        }}>
                                                            Curriculumn Management
                                                        </Menu.Item>

                                                        <Menu.Item key="4" icon={<DiffOutlined/>} onClick={(e) => {
                                                            testFunction(e.key);
                                                        }}>
                                                            Course Management
                                                        </Menu.Item>

                                                        <Menu.Item key="5" icon={<DiffOutlined/>} onClick={(e) => {
                                                            testFunction(e.key);
                                                        }}>
                                                            Discipline Management
                                                        </Menu.Item>
                                                    </Menu>

                                                </Sider>

                                                <Content style={{
                                                    padding: "0 20px",
                                                    minHeight: 280,
                                                    backgroundColor: "white"
                                                }}>

                                                    <div className="site-layout-background"
                                                         style={{marginLeft: "15px", padding: 24, minHeight: "100%"}}>
                                                        <TabPanel value={value} index="1">
                                                            <ProgramInformation/>
                                                        </TabPanel>

                                                        <TabPanel value={value} index="2">
                                                            <EnrolledStudents/>
                                                        </TabPanel>

                                                        <TabPanel value={value} index="3">
                                                            <CurriculumManagement/>
                                                        </TabPanel>

                                                        <TabPanel value={value} index="4">
                                                            <CourseManagement/>
                                                        </TabPanel>
                                                        
                                                        <TabPanel value={value} index="5">
                                                            <DisciplineManagement/>
                                                        </TabPanel>
                                                    </div>
                                                </Content>
                                            </Layout>
                                        </Content>
                                    </Layout>
                                </div>
                            </section>
                        </div>
                    </div>
                </section>
            </div>
        </Fragment>
    );
}

export default ProgramDetails;